import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { QuarryTypeService } from '../proxy/controlling/controllers/quarry-type.service';
import { RoadDistanceService } from '../proxy/controlling/controllers/road-distance.service';
import { RoadCargoTypeService } from '../proxy/controlling/controllers/road-cargo-type.service';
import { ScopeTypeService } from '../proxy/controlling/controllers/scope-type.service';
import { StageService } from '../proxy/controlling/controllers/stage.service';
import { VendorService } from '../proxy/controlling/controllers/vendor.service';
import { ActivityProcessParametrizationService } from '../proxy/controlling/controllers/activity-process-parametrization.service';
import { WbsService } from '@controlling/proxy/controlling/controllers';

FieldBuilder.setNamespace('Controlling');

export const ROADACTIVITYPARAMETER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .checkbox('isVisibleFromMobile', 'Entity.RoadActivityParameter.IsVisibleFromMobile')
    .build(),
  FieldBuilder
    .checkbox('isMaterial', 'Entity.RoadActivityParameter.IsMaterial')
    .build(),
  FieldBuilder
    .foreignKey('quarryTypeId', 'Entity.QuarryType', QuarryTypeService)
    .displayFromNested('quarryType.name')
    .sortBy('quarryType.name')
    .build(),
  FieldBuilder
    .foreignKey('roadDistanceId', 'Entity.RoadDistance', RoadDistanceService)
    .displayFromNested('roadDistance.name')
    .sortBy('roadDistance.name')
    .build(),
  FieldBuilder
    .foreignKey('roadCargoTypeId', 'Entity.RoadCargoType', RoadCargoTypeService)
    .displayFromNested('roadCargoType.name')
    .sortBy('roadCargoType.name')
    .build(),
  FieldBuilder
    .foreignKey('scopeTypeId', 'Entity.ScopeType', ScopeTypeService)
    .displayFromNested('scopeType.name')
    .sortBy('scopeType.name')
    .build(),
  FieldBuilder
    .foreignKey('stageId', 'Entity.Stage', StageService)
    .displayFromNested('stage.name')
    .sortBy('stage.name')
    .build(),
  FieldBuilder
    .foreignKey('wbsId', 'Entity.Wbs', WbsService)
    .displayFromNested('wbs.name')
    .sortBy('wbs.name')
    .build(),
  FieldBuilder
    .foreignKey('activityProcessParametrizationId', 'Entity.ActivityProcessParametrization', ActivityProcessParametrizationService)
    .required()
    .displayFromNested('activityProcessParametrization.name')
    .sortBy('activityProcessParametrization.name')
    .hideInChildForms()
    .build(),
];

export const ROADACTIVITYPARAMETER_CONFIG = {
  entityName: 'RoadActivityParameter',
  localizationKey: 'Controlling::Entity.RoadActivityParameter',
  fields: ROADACTIVITYPARAMETER_FIELDS,
  permission: 'ControllingActivities.RoadActivityParameters',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
